const OverlandExpresss = () => {
    return (
      <div>
          <div className="flex flex-col justify-center items-center">
          <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
             
              <div className="flex flex-col justify-center">
                <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                  Overland Express 
                </h1>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                  With its bulk cargo movements to around 200 cities of the country, and a transit time of 36–72 hours, 
                  TCS Overland Express is the preferred choice of the corporate customer base when it comes to secured, 
                  economical and time-definite transportation of heavy cargo shipments to any part of the country. 
                  Our large customer base includes: pharmaceutical companies, financial organisations, major printing houses, 
                  automobile industries, cellular industry, and more.
                </p>
                {/* <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                TCS Overland Express is the preferred choice of a large corporate customer base when it comes to secured, 
                economical and time definite transportation of heavy cargo shipments to any part of the country. Our large 
                customer base includes: Pharmaceutical companies, Banking sector, Major printing houses, Automotive 
                industries, Cellular industry.
                </p> */}
              </div>
              <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                <img src="/DomesticScrollingBanner/scrolling-image19.jpg" alt="" className="rounded-md max-w-[100%]"/>
              </div>
            </div>
          
          </div>
        </div>
    
    )
};
export default OverlandExpresss;